{
  "aiGeneratedAnswer": "Odpoveď generovaná AI",
  "allCategories": "Všetky kategórie",
  "appliedFiltersToCurrentSearch": "Použité filtre na aktuálne vyhľadávanie",
  "apply": "Použiť",
  "applyFilters": "Použiť filtre",
  "autocompleteOptionsFound_few": "Nájdené {{count}}{{label}} možnosti automatického dopĺňania.",
  "autocompleteOptionsFound_one": "Nájdená {{count}}{{label}} možnosť automatického dopĺňania.",
  "autocompleteOptionsFound_other": "Nájdených {{count}}{{label}} možností automatického dopĺňania.",
  "autocompleteSuggestion": "návrh automatického dopĺňania: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Nájdené {{count}} návrhy automatického dopĺňania.",
  "autocompleteSuggestionsFound_one": "Nájdený {{count}} návrh automatického dopĺňania.",
  "autocompleteSuggestionsFound_other": "Nájdených {{count}} návrhov automatického dopĺňania.",
  "basedOnYourDevice": " (na základe vášho zariadenia)",
  "basedOnYourInternetAddress": " (na základe vašej internetovej adresy)",
  "categoriesText_few": "Nasledujúce kategórie priniesli výsledky pre – <strong>{{query}}</strong>",
  "categoriesText_one": "Nasledujúca kategória priniesla výsledky pre – <strong>{{query}}</strong>",
  "categoriesText_other": "Nasledujúcych kategórií prinieslo výsledky pre – <strong>{{query}}</strong>",
  "clearAll": "Vymazať všetko",
  "clearMinAndMax": "Vymazať min a max",
  "clearTheRangeToSelectOptions": "Vymazať rozsah na výber možností.",
  "clearTheSearchBar": "Vymazať vyhľadávací panel",
  "conductASearch": "Vykonať vyhľadávanie",
  "currentLocation": "Aktuálna poloha",
  "didYouMean": "Mali ste na mysli <button>{{correctedQuery}}</button>?",
  "dropDownScreenReaderInstructions": "Keď sú k dispozícii výsledky automatického dokončenia, použite šípky nahor a nadol na preskúmanie a enter na výber.",
  "feedback": "Spätná väzba",
  "invalidRange": "Neplatný rozsah",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Prejsť na ďalšiu stránku výsledkov",
  "navigateToThePreviousResultsPage": "Prejsť na predchádzajúcu stránku výsledkov",
  "noAutocompleteOptionsFound": "0 nájdených možností automatického dokončenia.",
  "noAutocompleteSuggestionsFound": "0 nájdených návrhov automatického dokončenia.",
  "noResultsFoundIn": "Nenašli sa žiadne výsledky v {{currentVerticalLabel}}.",
  "pagination": "Stránkovanie",
  "readMoreAbout": "Čítať viac o <a>{{name}}</a>",
  "recentSearch": "nedávne vyhľadávanie: {{query}}",
  "recentSearchesFound_few": "Nájdené {{count}} nedávne vyhľadávania.",
  "recentSearchesFound_one": "Nájdené {{count}} nedávne vyhľadávanie.",
  "recentSearchesFound_other": "Nájdených {{count}} nedávnych vyhľadávaní.",
  "removeFilter": "Odstrániť filter „{{displayName}}“",
  "resultPreview": "výsledkový náhľad: {{value}}",
  "resultPreviewsFound_few": "Nájdené {{count}} náhľady výsledkov.",
  "resultPreviewsFound_one": "Nájdený {{count}} náhľad výsledku.",
  "resultPreviewsFound_other": "Nájdených {{count}} náhľadov výsledkov.",
  "resultsCountText_few": "{{count}} výsledky",
  "resultsCountText_one": "{{count}} výsledok",
  "resultsCountText_other": "{{count}} výsledkov",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} z {{resultsCount}} výsledkov",
  "searchHere": "Vyhľadajte tu…",
  "showLess": "Zobraziť menej",
  "showMore": "Zobraziť viac",
  "showingAllInstead": "Zobrazujú sa všetky položky v {{currentVerticalLabel}}.",
  "sources_few": "Zdroje ({{count}})",
  "sources_one": "Zdroj",
  "sources_other": "Zdroje ({{count}})",
  "submitSearch": "Odovzdať",
  "suggestionResultsCount_few": "{{label}} – {{count}} výsledky",
  "suggestionResultsCount_one": "{{label}} – {{count}} výsledok",
  "suggestionResultsCount_other": "{{label}} – {{count}} výsledkov",
  "thankYouForYourFeedback": "Ďakujeme za vašu spätnú väzbu!",
  "thisAnsweredMyQuestion": "Toto odpovedalo na moju otázku",
  "thisDidNotAnswerMyQuestion": "Toto neodpovedalo na moju otázku",
  "unselectAnOptionToEnterInARange": "Zrušte výber možnosti, aby ste mohli zadať rozsah.",
  "updateYourLocation": "Aktualizujte svoju polohu",
  "useCurrentLocation": "Použiť aktuálnu polohu",
  "useMyLocation": "Použiť moju polohu",
  "viewAll": "Zobraziť všetko",
  "viewDetails": "Zobraziť podrobnosti"
}
